export const columns = [
  {
    title: 'page_tenant_operation',
    key: 'action',
    width: 90,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: '查看',
    key: 'read',
    width: 90,
    scopedSlots: { customRender: 'read' }
  },
  {
    title: "参数名称",
    dataIndex: "paramName",
    key: "paramName",
    ellipsis: true,
  },
  {
    title: "参数键名",
    dataIndex: "paramKey",
    key: "paramKey",
    ellipsis: true,
  },
  {
    title: "参数键值",
    dataIndex: "paramValue",
    key: "paramValue",
    ellipsis: true,
  },
]
